<template >
  <div style="width: 100%;" v-if="imageList.length > 0">
    <img v-for="(img, index) in imageList" :key="index" v-lazy="img" style="width: 100%;">
  </div>
</template>

<script>
import { Row, Col, Uploader, Icon, Button, Cell, CellGroup } from 'vant'
// import request from '@/utils/request'

export default {
  name: 'OrderAttachment',
  components: {
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  data() {
    return {
      // imageList: [
      //   // 'https://img.yzcdn.cn/1.jpg'
      //   'https://img.yzcdn.cn/2.jpg'
      // ]
    }
  },
  props: {
    imageList: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    //
  },
  created: function() {
    // Add barcode scan listener and pass the callback function
    // this.RegisterWxJsApi()
  }
}
</script>

<style lang="less" scoped>
</style>
